import { render, staticRenderFns } from "./DropdownSlotted.vue?vue&type=template&id=2689e1ea&scoped=true"
import script from "./DropdownSlotted.vue?vue&type=script&lang=ts"
export * from "./DropdownSlotted.vue?vue&type=script&lang=ts"
import style0 from "./DropdownSlotted.vue?vue&type=style&index=0&id=2689e1ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2689e1ea",
  null
  
)

export default component.exports